import { OpenSearchHit } from './types';

export const getNestedValue = (value: any, path: string): any =>
  path
    .split('.')
    .reduce<any>(
      (current, key) => (current != null ? current[key] : undefined),
      value
    );

export const getFirstString = (...values: any[]): string => {
  for (const value of values) {
    if (typeof value === 'string' && value.trim()) {
      return value;
    }
  }

  return '';
};

export const getHighlightValue = (
  hit: OpenSearchHit,
  attribute: string,
  property: '_highlightResult' | '_snippetResult'
): string => {
  const result = getNestedValue(hit[property], attribute);

  if (result && typeof result === 'object' && typeof result.value === 'string') {
    return result.value;
  }

  return getFirstString(getNestedValue(hit, attribute));
};

export const getOpenSearchPostTitle = (hit: OpenSearchHit): string =>
  getFirstString(
    hit.title,
    hit.blog?.title,
    hit.poll?.title,
    hit.question?.title,
    hit.answer?.question?.title,
    hit.answer?.body,
    hit.bodyPlainText,
    'Post'
  );

export const getOpenSearchPostBodyAttribute = (hit: OpenSearchHit): string => {
  switch (hit.postType) {
    case 'BLOG':
      return 'blog.content';
    case 'POLL':
      return 'poll.description';
    case 'QUESTION':
      return 'question.body';
    case 'ANSWER':
      return 'answer.body';
    default:
      return 'bodyPlainText';
  }
};

const getOpenSearchSimplePostPath = (hit: OpenSearchHit, postId: string): string => {
  const hasGroup = Boolean(
    getFirstString(hit.groupId, hit.group?._id, hit.group?.id)
  );
  return hasGroup ? `/community/post/${postId}` : `/post/${postId}`;
};

export const getOpenSearchPostUrl = (hit: OpenSearchHit): string => {
  const postId = getFirstString(hit.postId, hit.sourceId, hit.objectID);
  const simplePostPath = getOpenSearchSimplePostPath(hit, postId);

  switch (hit.postType) {
    case 'BLOG':
      return hit.blog?._id || hit.blog?.id
        ? `/blog/${hit.blog._id || hit.blog.id}`
        : simplePostPath;
    case 'POLL':
      return hit.poll?._id || hit.poll?.id
        ? `/poll/${hit.poll._id || hit.poll.id}`
        : simplePostPath;
    case 'QUESTION':
      return hit.question?._id || hit.question?.id
        ? `/question/${hit.question._id || hit.question.id}`
        : simplePostPath;
    case 'ANSWER':
      return hit.answer?.question?._id || hit.answer?.question?.id
        ? `/question/${hit.answer.question._id || hit.answer.question.id}`
        : simplePostPath;
    default:
      return simplePostPath;
  }
};

export const getOpenSearchFileUrl = (hit: OpenSearchHit): string => {
  const versionFileId = getFirstString(
    hit.versionFileId,
    hit.sourceId,
    hit.objectID
  );
  const groupId = getFirstString(hit.groupId);

  if (groupId) {
    return `/community/groups/${groupId}/resources?versionFileId=${versionFileId}`;
  }

  const originalPostId = getFirstString(hit.originalPostId);
  return originalPostId ? `/post/${originalPostId}` : '/community';
};
